<template>
    <div>
        <b-card>
          <h3>Cooling Towers</h3>
          <br/>
          <b-row>
            <b-col>These questions can be defaulted if no configuration required</b-col>
            <b-col><b-button variant="outline-info" v-on:click="SkipPage()">Use Default Values</b-button></b-col>
          </b-row>
          <hr/>
          <b-row>
            <b-col cols="1">Q1</b-col>
            <b-col align="left">System Min Temp</b-col>
            <b-col><b-form-input type="number" step="0.50" min="0.00" max="100.00" v-model="Values.CoolingTowers.TowerTempMin" placeholder="00.00"></b-form-input></b-col>
            <b-col align="left">&deg;C</b-col>
          </b-row>
          <b-row>
            <b-col cols="1">Q2</b-col>
            <b-col align="left">System Max Temp</b-col>
            <b-col><b-form-input type="number" step="0.50" min="0.00" max="100.00" v-model="Values.CoolingTowers.TowerTempMax" placeholder="00.00"></b-form-input></b-col>
            <b-col align="left">&deg;C</b-col>
          </b-row>
          <b-row>
            <b-col cols="1">Q3</b-col>
            <b-col align="left">No Flow Threshold</b-col>
            <b-col><b-form-input type="number" v-model="Values.CoolingTowers.TowerFlow" placeholder="00"></b-form-input></b-col>
            <b-col align="left">Hours</b-col>
          </b-row>
          <hr/>
          <b-row><b-col><b-button variant="outline-success" v-if="stepComplete == false" v-on:click="CompletePage()">Page Complete</b-button></b-col></b-row>

        </b-card>
    </div>
</template>

<script>
    export default {
      props:['DataPass','Type','ID'],
      data() {
      return {
        stepComplete: false,
        InvalidNum: false,
        Values:{
          CoolingTowers: {
                TowerTempMax: "",
                TowerTempMin: "",
                TowerFlow: ""
                    },
      }
    }
    },
    computed: {},
    components: {},
    mounted(){
      if (this.Type == 'Modify'){
        this.Values.CoolingTowers.TowerTempMax = this.DataPass.CoolingTowers.TowerTempMax
        this.Values.CoolingTowers.TowerTempMin = this.DataPass.CoolingTowers.TowerTempMin
        this.Values.CoolingTowers.TowerFlow = this.DataPass.CoolingTowers.TowerFlow
      }else{
        this.Values.CoolingTowers.TowerTempMax = 25.00
        this.Values.CoolingTowers.TowerTempMin = 5.00
        this.Values.CoolingTowers.TowerFlow = 24
      }


       
    },
    methods:{
      CompletePage(){
        if (this.NumberCheck(this.Values) == true){
          alert("Please ensure entries contain only valid numbers")
        } else{
        this.$emit("PageComplete",5,this.Values)
        this.stepComplete = true;
        }
      },
      SkipPage(){
        this.Values.CoolingTowers.TowerTempMax = 25.00
        this.Values.CoolingTowers.TowerTempMin = 5.00
        this.Values.CoolingTowers.TowerFlow = 24

        this.$emit("PageComplete",5,this.Values)
        this.stepComplete = true;
      },
      NumberCheck(data){
        this.InvalidNum = false
        
        let invalidtowermax = /^\d{1,3}(\.\d+)?$/.test(data.CoolingTowers.TowerTempMax)
        let invalidtowermin = /^\d{1,3}(\.\d+)?$/.test(data.CoolingTowers.TowerTempMin)
        let invalidtowerflow = /^\d{1,3}(\.\d+)?$/.test(data.CoolingTowers.TowerFlow)
        
        
        if (!invalidtowermax || !invalidtowermin || !invalidtowerflow){
          this.InvalidNum = true
        }

        return this.InvalidNum
      }
    },

    }
</script>

<style>

</style>